// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table, th,
td {
  border: 1px solid;
}

th,
td {
  vertical-align: middle !important;
}

#delete {
  color: rgb(224, 71, 71);
}

#update {
  color: grey;
}

#sort {
  color: grey;
}

.cdk-drag-preview {
  border: none;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
  vertical-align: middle !important;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.clicked-row {
  background-color: rgb(121, 117, 117) !important;
  pointer-events: none;
}

.activeCol {
  color: #28a745;
  font-weight: bold;
}

.updatedCol {
  color: #007BFF;
  font-weight: bold;
}

.deletedCol {
  color: #dc3545;
  font-weight: bold;
}

.upStatus {
  color: #28a745;
  font-weight: bold;
}

.downStatus {
  color: red;
  font-weight: bold;
}

.table tbody tr {
  cursor: pointer !important;
  transition: background-color 0.2s ease-in-out;
}

.table tbody tr:hover td {
  background-color: #d4d9e0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/table/table.component.scss"],"names":[],"mappings":"AAAA;;EAEE,iBAAA;AACF;;AAEA;;EAEE,iCAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,qHAAA;AAIF;;AAAA;EACE,UAAA;EACA,iCAAA;AAGF;;AAAA;EACE,sDAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,sDAAA;AAGF;;AAAA;EACE,+CAAA;EAKA,oBAAA;AADF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,UAAA;EACA,iBAAA;AAFF;;AAKA;EACE,0BAAA;EACA,6CAAA;AAFF;;AAKA;EACE,oCAAA;AAFF","sourcesContent":["table, th,\r\ntd {\r\n  border: 1px solid;\r\n}\r\n\r\nth,\r\ntd {\r\n  vertical-align: middle !important;\r\n}\r\n#delete {\r\n  color: rgb(224, 71, 71);\r\n}\r\n#update {\r\n  color: grey;\r\n}\r\n#sort {\r\n  color: grey;\r\n}\r\n\r\n.cdk-drag-preview {\r\n  border: none;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\r\n    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cdk-drag-placeholder {\r\n  opacity: 0;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.cdk-drag-animating {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.example-box:last-child {\r\n  border: none;\r\n}\r\n\r\n.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.clicked-row {\r\n  background-color: rgb(\r\n    121,\r\n    117,\r\n    117\r\n  ) !important; // Change the color of the row\r\n  pointer-events: none; // Disable any interaction with the row\r\n}\r\n\r\n\r\n.activeCol {\r\n  color: #28a745;\r\n  font-weight: bold;\r\n}\r\n\r\n.updatedCol {\r\n  color: #007BFF;\r\n  font-weight: bold;\r\n}\r\n\r\n.deletedCol{\r\n  color: #dc3545;\r\n  font-weight: bold;\r\n}\r\n\r\n.upStatus{\r\n  color: #28a745;\r\n  font-weight: bold;\r\n}\r\n\r\n.downStatus{\r\n  color: red;\r\n  font-weight: bold;\r\n}\r\n\r\n.table tbody tr {\r\n  cursor: pointer !important;\r\n  transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n.table tbody tr:hover td {\r\n  background-color: #d4d9e0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
